import Services from './services';
import Config from '../Config';

const LoginModel = {
    login: (criteria) => {
        return Services.postApi(Config.getAuthBasePath() + '/oauth/token', criteria, true);
    },
};

export default LoginModel;
